<template>
  <div class="drivers-workspace">
    <div class="drivers-workspace__content">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'WorkspaceLayout' });
</script>

<style scoped>
.drivers-workspace {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
}

.drivers-workspace__content {
  width: var(--crc-page-content-width);
  max-width: var(--crc-page-content-max-width);
  margin-inline: auto;
  padding: var(--crc-shell-inset-y) max(var(--crc-shell-inset-x), 32px);
  background: var(--crc-workspace-overlay);
  min-height: 100%;
  min-width: 0;
  box-sizing: border-box;
}
</style>
